console.log("curated for you");

const RECOMMENDATION_NAME = "curated-for-you-placement";

// Nosto's feed is priced in the store's base currency regardless of the buyer's market, so its
// prices are rendered with the base format and corrected below for other currencies.
const NOSTO_MONEY_FORMAT = "${{ amount_no_decimals }}";

const presentmentPriceCache = new Map();

function moneyFormatNoDecimals() {
  return (
    (window.WIP && window.WIP.money && window.WIP.money.noDecimalsFormat) ||
    NOSTO_MONEY_FORMAT
  );
}

function isBaseCurrency() {
  if (!window.WIP || !window.WIP.money || typeof window.WIP.money.isBaseCurrency !== "function") {
    return true;
  }

  return window.WIP.money.isBaseCurrency();
}

function fetchPresentmentPrice(handle) {
  if (!presentmentPriceCache.has(handle)) {
    presentmentPriceCache.set(
      handle,
      fetch(`/products/${handle}?view=data`)
        .then((res) => (res.ok ? res.json() : null))
        .then((data) => (data && typeof data.price === "number" ? data.price : null))
        .catch(() => null)
    );
  }

  return presentmentPriceCache.get(handle);
}

/**
 * Replace the base-currency Nosto price with Shopify's presentment price. The store prices its
 * markets manually rather than by exchange rate, so the amount has to come from Shopify — it
 * cannot be derived from `Shopify.currency.rate`. Done lazily per tile to avoid firing a request
 * per product on a 100-item page.
 */
function localizeCuratedPrices() {
  if (isBaseCurrency()) return;

  const format = moneyFormatNoDecimals();
  const nodes = document.querySelectorAll("[data-curated-price][data-curated-handle]");

  const localize = (el) => {
    const handle = el.dataset.curatedHandle;

    if (!handle || el.dataset.curatedPriceLocalized) return;
    el.dataset.curatedPriceLocalized = "true";

    fetchPresentmentPrice(handle).then((price) => {
      if (price == null) return;
      el.textContent = window.Shopify.formatMoney(price, format);
    });
  };

  if (!("IntersectionObserver" in window)) {
    nodes.forEach(localize);
    return;
  }

  const observer = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        if (!entry.isIntersecting) return;
        observer.unobserve(entry.target);
        localize(entry.target);
      });
    },
    { rootMargin: "200px" }
  );

  nodes.forEach((el) => observer.observe(el));
}

class ArrayPaginator {
  constructor(array, itemsPerPage = 10) {
    this.array = array;
    this.itemsPerPage = itemsPerPage;
    this.currentPage = this.getPageFromURL() || 1;
  }
  
  getPageFromURL() {
    const urlParams = new URLSearchParams(window.location.search);
    const pageParam = urlParams.get('page');
    const page = parseInt(pageParam, 10);
    
    // Validate the page number
    if (isNaN(page) || page < 1) {
      return null;
    }
    
    const totalPages = Math.ceil(this.array.length / this.itemsPerPage);
    return page <= totalPages ? page : null;
  }
  
  updateURL(page) {
    const url = new URL(window.location);
    if (page === 1) {
      url.searchParams.delete('page');
    } else {
      url.searchParams.set('page', page);
    }
    window.history.pushState({}, '', url);
  }
  
  getPage(page = this.currentPage) {
    const totalPages = this.getTotalPages();
    
    if (page < 1 || page > totalPages) {
      throw new Error(`Page ${page} is out of range (1-${totalPages})`);
    }
    
    this.currentPage = page;
    this.updateURL(page);
    const startIndex = (page - 1) * this.itemsPerPage;
    const endIndex = startIndex + this.itemsPerPage;
    
    return {
      data: this.array.slice(startIndex, endIndex),
      currentPage: page,
      totalPages,
      totalItems: this.array.length,
      itemsPerPage: this.itemsPerPage,
      hasNext: page < totalPages,
      hasPrev: page > 1
    };
  }
  
  next() {
    return this.getPage(this.currentPage + 1);
  }
  
  prev() {
    return this.getPage(this.currentPage - 1);
  }
  
  first() {
    return this.getPage(1);
  }
  
  last() {
    return this.getPage(this.getTotalPages());
  }
  
  getTotalPages() {
    return Math.ceil(this.array.length / this.itemsPerPage);
  }
}

function deferNostoLoad(fn) {
  if (window.nostojs) {
    fn();
  } else {
    setTimeout(function () {
      deferNostoLoad(fn);
    }, 50);
  }
}

function buildItem(product) {
  return `
  <li>
    <a href="${product.url}">
       <img src="${product.image_url}" style="aspect-ratio: 1 / 1;" />
       <div class="curated-item__body">
         <p class="category-product__title">${product.name}</p>
         <div class="curated-row">
          <span data-curated-price data-curated-handle="${product.handle}">${window.Shopify.formatMoney(
            product.price * 100,
            NOSTO_MONEY_FORMAT
          )}</span>
          <button
            data-action="add"
            data-product="${product.product_id}"
            class="w-full category-product__wishlistbtn item-wishlist-add flex items-center justify-end text-right font-semibold uppercase py-0 px-4">
            
            <div class="wishlist-icon small mt-0.5 false" style="flex-shrink: 0;"></div><span>Add To Wishlist</span>
          </button>
          
         </div>
       </div>
    </a>
    <script type="text" product-source>
      ${JSON.stringify(product)}
    </script>
  </li>
  `;
}

function createPagination(totalPages, currentPage = 1) {
  const pages = Array(totalPages).fill(1).map((n,i) => i + 1);

  const itemsHtml = pages.map((page) => `
    <li class="curated-pagination__item">
       <a class="curated-pagination__item ${currentPage === page ? 'active-page' : ''}" href="${window.location.pathname}?page=${page}">${page}</a>
    </li>
  `).join('');

  const html = `
  <nav class="curated-pagination">
    <ol class="curated-pagination__list">
    ${itemsHtml}
    </ol>
  </nav>
  `

  document.getElementById("curatedForYou").innerHTML += html;
}

function handleNostoResponse(campaigns) {
  console.log("[handleNostoResponse] curated:", campaigns);

  var campaign = campaigns.recommendations[RECOMMENDATION_NAME];
  var nostoProducts = campaigns.recommendations[RECOMMENDATION_NAME].products;
  var nostoParams = campaigns.recommendations[RECOMMENDATION_NAME].params;
  const productPaginations = new ArrayPaginator(nostoProducts, 100);
  const totalPages = productPaginations.getTotalPages();
  const currentPage= productPaginations.currentPage;
  const page = productPaginations.getPage();
  const products = page.data || [];

  var nostoParamsURL = "";

  
  console.log("[handleNostoResponse] currentPage:", currentPage, page);

  document.getElementById("curatedForYou").innerHTML = products
    .map(buildItem)
    .join("");

  recordViewCategoryAttribution({
    target: campaign.result_id
  })


  if(totalPages > 1) {
    createPagination(totalPages, currentPage)
  }

  // Must run after createPagination — it appends via `innerHTML +=`, which re-parses the whole
  // container and would drop the observers and flags set below.
  localizeCuratedPrices();

  console.log(
    "Nosto Response Campaigns:",
    campaigns,
    { totalPages },
    nostoParams,
    nostoProducts
  );
  
  if (typeof window.Wishlist_API.gatherPageProduct === 'function') window.Wishlist_API.gatherPageProduct();
}

/* send nosto attribution since viewing via js api. */
function recordViewCategoryAttribution({
  target
}) {
  return recordNostoAttribute({
      type: 'vc',
      target,
      refType: 'api'
  })
}

function recordNostoAttribute(payload) {
  window.nostojs((api) => {
    api.recordAttribution(payload)
  })
}

function initialize() {
  deferNostoLoad(() =>
    window.nostojs((api) => {
      api.setAutoLoad(false);
      api
        .defaultSession()
        .viewFrontPage()
        .setPlacements(api.placements.getPlacements())
        .load()
        .then((response) => {
          console.log('[nosto curated] ', response);

          handleNostoResponse(response.campaigns)
        });

    })
  );
}

initialize();
